import React, { createContext, useContext, ReactNode } from "react";
import { useParams, useNavigate } from "react-router-dom";

interface ClientContextType {
  currentClient: string;
  setClient: (client: string) => void;
}

const ClientContext = createContext<ClientContextType | undefined>(undefined);

export const useClient = () => {
  const context = useContext(ClientContext);
  if (context === undefined) {
    throw new Error("useClient must be used within a ClientProvider");
  }
  return context;
};

interface ClientProviderProps {
  children: ReactNode;
}

export const ClientProvider: React.FC<ClientProviderProps> = ({ children }) => {
  const { client } = useParams<{ client: string }>();
  const navigate = useNavigate();

  const currentClient = client || "default";

  const setClient = (newClient: string) => {
    navigate(`/${newClient}`, { replace: false });
  };

  const contextValue: ClientContextType = {
    currentClient,
    setClient,
  };

  return (
    <ClientContext.Provider value={contextValue}>
      {children}
    </ClientContext.Provider>
  );
};
